export enum WalletType {
	BSC = "BSC",
	TRON = "TRON",
	TON = "TON",
}
